<template>
  <div class="reports">
    <h2>评论举报队列</h2>
    <el-radio-group v-model="statusFilter" @change="reload" size="small" style="margin-bottom: 12px">
      <el-radio-button :label="0">待处理</el-radio-button>
      <el-radio-button :label="1">已处理</el-radio-button>
      <el-radio-button :label="2">已驳回</el-radio-button>
    </el-radio-group>

    <el-table :data="items" v-loading="loading" border size="small">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column label="被举报评论">
        <template slot-scope="{row}">
          <div style="white-space:pre-wrap; max-height:80px; overflow:auto">{{ row.comment.content }}</div>
          <small>(comment #{{ row.comment.id }}, 状态: {{ row.comment.status === 1 ? '可见' : '隐藏' }}<span v-if="row.comment.deleted_at">/已删</span>)</small>
        </template>
      </el-table-column>
      <el-table-column label="举报人" width="140">
        <template slot-scope="{row}">{{ row.reporter.nickname }} (#{{ row.reporter.id }})</template>
      </el-table-column>
      <el-table-column prop="reason" label="原因" width="100">
        <template slot-scope="{row}">{{ reasonLabel(row.reason) }}</template>
      </el-table-column>
      <el-table-column prop="detail" label="备注" />
      <el-table-column prop="created_at" label="时间" width="160" />
      <el-table-column label="操作" width="240">
        <template slot-scope="{row}">
          <template v-if="row.status === 0">
            <el-button size="mini" type="danger" @click="onResolve(row, true)">隐藏并标处理</el-button>
            <el-button size="mini" @click="onResolve(row, false)">仅标处理</el-button>
            <el-button size="mini" type="info" @click="onDismiss(row)">驳回</el-button>
          </template>
          <span v-else>已处理</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 12px"
      layout="prev, pager, next, total"
      :total="total" :page-size="pageSize" :current-page.sync="page"
      @current-change="reload"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { listReports, handleReport, CommentReport } from '@/api/comment'

@Component
export default class CommentReports extends Vue {
  statusFilter = 0
  items: CommentReport[] = []
  loading = false
  page = 1
  pageSize = 20
  total = 0

  mounted() { this.reload() }

  async reload() {
    this.loading = true
    try {
      const res = await listReports({
        status: this.statusFilter,
        page: this.page, page_size: this.pageSize,
      })
      this.items = res.items
      this.total = res.total
    } finally { this.loading = false }
  }

  reasonLabel(r: string) {
    return ({
      spam: '垃圾广告', abuse: '辱骂攻击', sexual: '色情低俗',
      political: '政治敏感', other: '其它',
    } as Record<string,string>)[r] ?? r
  }

  async onResolve(row: CommentReport, hideComment: boolean) {
    await handleReport(row.id, 'resolve', hideComment)
    this.$message.success('已处理')
    this.reload()
  }
  async onDismiss(row: CommentReport) {
    await handleReport(row.id, 'dismiss', false)
    this.$message.success('已驳回')
    this.reload()
  }
}
</script>

<style scoped>
.reports { padding: 16px; }
</style>
